<template>
  <modal name="about-modal" class="q-modal about" :class="ifTop"
    transition="nice-modal-fade"
    :width="360"
    :min-width="360"
    :min-height="414"
    :height="414"
    :delay="100"
    :draggable="'.modal-header'"
    :clickToClose="false"
    :adaptive=true
    classes='q-v--modal'
    >
      <div class="modal-content">
        <div class="modal-header">{{$t('about.title')}}</div>
        <div class="icon-btn_close modal-close" @click="onClose()"></div>
        <div class="modal-body">
          <div class="iconIntro">
            <logo class="icon"/>
            <!-- <img src="../assets/qsw.png" class="icon" /> -->
            <!-- <div class="icon-qunetswitch qpkgName"></div> -->
            <div class="qpkg-name">{{about.model}}</div>
            <span class="version">{{$t('about.version')}} {{about.version}} ({{about.build | getDate}})</span>
          </div>
        </div>
        <div class="modal-footer">
          <div class="footer-left">
            <div class="copyrightinfo">
              <span class="icon-qnap qnaplogo"></span>
              <a href="https://www.qnap.com/" target="_blank" ><span class="qnapwebsite a_text_underline">www.qnap.com</span></a>
              <p class="copyright">{{$t('about.copyright', getYear())}} </p>
            </div>
          </div>
          <div class="footer-right">
            <div class="qtslogo">
              <!-- <img src="../assets/about/ic_qts_smallicon.png" class="qtslogo" /> -->
            </div>
          </div>
        </div>
      </div>
  </modal>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import logo from '../assets/svg/icon_about_logo.svg'
export default {
  name: 'About',
  components: {
    logo
  },
  data () {
    return {
      modalname: 'about-modal',
      showModal: true
    }
  },
  filters: {
    getDate (value) {
      if (value) {
        let temp = value.split('T')
        return temp[0]
      }
    }
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal'
    ]),
    getYear () {
      let data = this.about.build
      if (data) {
        return data.substring(0, 4)
      }
    },
    onOpen () {
      this.openModal('about-modal')
      this.$modal.show('about-modal')
    },
    onClose () {
      this.closeModal('about-modal')
      this.$modal.hide('about-modal')
    }
  },
  computed: {
    ...mapState({
      about: state => state.module.about
    }),
    ...mapGetters(['getTopModalName']),
    ifTop () {
      this.$log.debug('this.getTopModalName :' + this.getTopModalName)

      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
@import '../assets/scss/modal.scss';

.about {
  z-index: 9999;
  .q-v--modal {
    border-radius: 12px;
    > .modal-content {
      height: 414px !important;
      > .modal-header {
        height: 40px;
        line-height: 40px;
        background: initial;
        color: #000000;
      }
      > .modal-close {
        top: 10px;
        right: 10px;
        color: #000;
        &:hover {
          color: #89A5F4;
        }
      }
      > .modal-body {
        height: 314px;
        .iconIntro {
          display: flex;
          flex-direction: column;
          justify-content: center;
          text-align: center;
          align-items: center;
          padding: 17px 0px 15px 0px;
          .icon {
            margin-bottom: 25px;
            width: 100px;
            height: 100px;
          }
          .qpkg-name {
            font-size: 25px;
            font-style: bold;
            font-family: 'Roboto-B', 'Microsoft JhengHei' !important;
          }
          .version {
            font-size: 13px;
            color: #474747;
            font-family: 'Roboto-R', 'Microsoft JhengHei';
          }
        }
      }
      > .modal-footer {
        padding: 0px 18px;
        border-top: none;
        display: flex;
        align-items: flex-end;
        .copyrightinfo {
          text-align: left;
          >img {
            margin-right: 6px;
          }
          .qnaplogo {
            color: #4a4a4a;
            &::before {
              font-size: 13px;
            }
          }
          .qnapwebsite {
            font-size: 12px;
            line-height: 12px;
            font-family: 'Roboto-R', 'Microsoft JhengHei';
          }
          .copyright {
            margin: 5px 0px 18px 0px;
            font-size: 10px;
            line-height: 10px;
            color: #262626;
            font-family: 'Roboto-R', 'Microsoft JhengHei';
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue